export default {
	nodeIter(nodelist, callback) {
		for (let i = 0, l = nodelist.length; i < l; i++) {
			callback(nodelist[i]);
		}
	},

	setLocation(url) {
		window.location = url;
	},
};
